import {useState} from "react";

export default function useDetailsEditModeSetter(resetFunction){
  const [editModeEnabled, setEditModeEnabled] = useState(false);
  const toggleEditModeEnabled = () => {
    resetFunction();
    setEditModeEnabled(!editModeEnabled);
  }
  return [editModeEnabled, toggleEditModeEnabled];
}